/**
 * Client-side auth session helpers (localStorage + user shape normalization).
 */

export const sanitizeAuthUser = (user) => {
  if (!user) {
    return null;
  }

  const roleRaw = user.role;
  const roleNum = roleRaw === undefined || roleRaw === null
    ? null
    : parseInt(roleRaw, 10);

  return {
    id: user.id,
    email: user.email,
    username: user.username,
    role: Number.isNaN(roleNum) ? roleRaw : roleNum,
    first_name: user.first_name,
    last_name: user.last_name,
    status: user.status,
    organization_id: user.organization_id ?? null,
    is_2fa_enabled: Boolean(user.is_2fa_enabled)
  };
};

export const getStoredAuthUser = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) {
      return null;
    }
    return sanitizeAuthUser(JSON.parse(raw));
  } catch {
    return null;
  }
};

export const hasStoredAuthSession = () => {
  const token = localStorage.getItem('accessToken');
  const user = getStoredAuthUser();
  return Boolean(token && user?.id);
};
